/* 
Mixins for use with history / system log components.
*/
export default {
  methods: {
    isMultiLine(v) {
      return v && v.includes("\n");
    },
    describeDifferences(before, after) {
      if (Array.isArray(before) || Array.isArray(after)) {
        return this.describeArrayDifferences(before, after);
      } else if (before && after) {
        return [`Changed from "${before}" to "${after}"`];
      } else if (before) {
        return [`"${before}" was cleared`];
      } else if (after) {
        return [`Set to "${after}"`];
      }
    },
    describeArrayDifferences(before, after) {
      if (before && after) {
        let results = [];
        for (let b of before) {
          if (!after.includes(b)) {
            results.push(`"${b}" was cleared`);
          }
        }
        for (let a of after) {
          if (!before.includes(a)) {
            results.push(`"${a}" was added`);
          }
        }
        return results;
      } else if (before) {
        return before.map(b => `"${b}" was cleared`);
      } else if (after) {
        return after.map(a => `"${a}" was added`);
      }
    },
    getLinks(log) {
      let links = [];
      if (log.levyCollectionId && log.providerId && !(this.levyCollectionId && this.providerId)) {
        links.push({
          url: `/levy-collections/${log.levyCollectionId}/providers/${log.providerId}`,
          description: "Levy collection provider"
        });
      }
      if (log.levyCollectionId && !this.levyCollectionId) {
        const inLevyCollection = this.invoiceId && this.$route.path.includes("/levy-collections/");
        if (!inLevyCollection) {
          links.push({ url: `/levy-collections/${log.levyCollectionId}`, description: "Levy collection" });
        }
      }
      if (log.levyCollectionId && log.noticeTemplateType && !(this.levyCollectionId && this.noticeTemplateType)) {
        links.push({
          url: `/levy-collections/${log.levyCollectionId}/setup/notices/${log.noticeTemplateType}`,
          description: "Notice template"
        });
      }
      if (log.invoiceId && !this.invoiceId) {
        if (this.levyCollectionId) {
          links.push({
            url: `/levy-collections/${this.levyCollectionId}/invoices/${log.invoiceId}`,
            description: "Invoice"
          });
        } else {
          links.push({ url: `/invoices/${log.invoiceId}`, description: "Invoice" });
        }
      }
      if (log.providerId && !this.providerId) {
        links.push({ url: `/providers/${log.providerId}`, description: "Provider" });
      }
      if (log.noticeId && !this.noticeId) {
        links.push({ description: "Notice", noticeId: log.noticeId });
      }
      if (log.roleId && !this.roleId) {
        links.push({ url: `/roles/${log.roleId}`, description: "Role" });
      }
      if (log.scheduledJobId && !this.scheduledJobId) {
        links.push({ url: `/scheduled-jobs/${log.scheduledJobId}`, description: "Scheduled job" });
      }
      return links;
    },
    getLinksWithAPage(log) {
      return this.getLinks(log).filter(k => k.url);
    },
    goTo(link) {
      if (link.url) {
        this.$router.push(link.url);
      } else if (link.noticeId) {
        this.currentNoticeId = link.noticeId;
        this.showNoticeViewDialog = true;
      }
    }
  }
};
